import { Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { decode } from "quoted-printable";
import React, { useMemo } from "react";
import { scrollbarStyle } from "../../../shared/dashboard";
import { EmailBody } from "../../../types/files";

const useStyles = makeStyles((theme) => ({
    emailBlock: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    bodyText: {
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        color: '#334155',
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
    },
}));

const EmailContent: React.FC<{ content: EmailBody }> = ({ content }) => {
    const classes = useStyles();

    const bodyText = useMemo(() => decode(content?.content || 'No content.').toString()
        .replace(/\r\n/g, '\n').split('\n')
        .map(line => {
            const match = line.match(/^([>]+)\s?(.*)$/);
            if (!match) return line;

            const depth = match[1]?.length;
            const content = match[2]?.trim();
            if (!content) return '';
            return ' '.repeat(depth) + content;
        }).join('\n')
    , [content?.content]);

    return (<>
        <Stack className={classes.emailBlock}>
            <Typography className={classes.bodyText}>
                {bodyText}
            </Typography>
        </Stack>
    </>);
}

export default EmailContent;
